// src/hooks/useFetchPatients.js
import { useState, useEffect } from "react";
import useDebounce from "./useDebounce";
import { useSelector } from "react-redux";
import API_BASE_URL from "../config";

const useFetchPatients = (searchTerm) => {
  const loginData = useSelector((state) => state.authSlice.user.CentreID);
  const token = useSelector((state) => state.authSlice.user.token);

  const [data, setData] = useState({
    labNo: loginData,
    patients: [],
    error: null,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Trim + Uppercase
  const processed = searchTerm.trim().toUpperCase();

  // ⚡ Reduce debounce to 400ms
  const debouncedSearch = useDebounce(processed, 400);

  useEffect(() => {
    // ❌ Do NOT fetch when search is empty
    if (!debouncedSearch) {
      setData({ labNo: loginData, patients: [], error: null });
      setLoading(false);
      return;
    }

    const fetchPatients = async () => {
      setLoading(true);

      try {
        const url = `${API_BASE_URL}/patient/search-patient/${debouncedSearch}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Network error");
        }

        const result = await response.json();
        setData({
          labNo: loginData,
          patients: result.patients || [],
          error: result.error ?? null,
        });
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPatients();
  }, [debouncedSearch, token, loginData]);

  return { data, loading, error };
};

export default useFetchPatients;
